import { Observable } from "rxjs";
import { HttpService } from "./http.service";
import { HttpHeaders, HttpParams } from "@angular/common/http";
import { GeneralPackageType } from "../../../interfaces/masters/generalpackagetype";
import { Injectable } from "@angular/core";

@Injectable()
export class Generalpackagetypeapi {
    constructor(private api: HttpService) { }

    list(url: string, options?: any): Observable<any[]> {
        const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
        return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
    }

    listStorageMst(url: string,tenantId:string,branchId:string,options?: any): Observable<any[]> {
        let queryParams = new HttpParams()
        .set('tenantId', tenantId.toString())
        .set('branchId', branchId.toString());
      return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json"}, params: queryParams});
    }

    listStorageMstById(url: string,id:string,options?: any): Observable<any[]> {
        let queryParams = new HttpParams()
        .set('id', id.toString())
      return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json"}, params: queryParams});
    }

    addStorageMst(url:string, data: any):Observable<any[]>{
        let header = new HttpHeaders();
        header.append('Content-Type', 'applications/json');
        header.append('Accept','application/vnd.ezovion.hateoas+json');
        return this.api.post( url, data, header);
    }
    
    add(url:string, data: GeneralPackageType):Observable<GeneralPackageType[]>{
        let header = new HttpHeaders();
        header.append('Content-Type', 'applications/json');
        header.append('Accept','application/vnd.ezovion.hateoas+json');
        return this.api.post( url, data, header);
    }
    
    update(url:string, data: GeneralPackageType):Observable<any>{
        let header = new HttpHeaders();
        header.append('Content-Type', 'applications/json');
        header.append('Accept','application/vnd.ezovion.hateoas+json');
        return this.api.put( url, data, {headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
    }

    updateStorageMstById(url:string,id:number,data: any):Observable<any>{
        let queryParams = new HttpParams()
        .set('id', id.toString())
      return this.api.put(url,data,{headers:{"Accept":"application/vnd.ezovion.hateoas+json"}, params: queryParams});
    }

    listStickerDet(url: string,forWhich:string,refNo:string,admId:number):Observable<any>{
        let queryParams = new HttpParams()
        .set('forWhich', forWhich.toString())
        .set('refNo', refNo.toString())
        .set('admId', admId.toString())
      return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json"}, params: queryParams});
    }

    listAbhaDet(url: string,valueSet:string):Observable<any>{
      let queryParams = new HttpParams()
      .set('valueSet', valueSet.toString())
    return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json"}, params: queryParams});
  }
}
